import { ContractPerson } from "@repo/api";
import { FC } from "react";
import { PersonDetailAddress } from "./PersonDetailAddress";
import * as Styled from "./PersonsAccordion.styled";

type PersonDetailCorrespondenceAddressProps = {
    person: ContractPerson;
};
export const PersonDetailCorrespondenceAddress: FC<PersonDetailCorrespondenceAddressProps> = ({ person }) => {
    return (
        <Styled.PersonsAccordionAddressBox>
            <PersonDetailAddress {...person.contactAddress} />
        </Styled.PersonsAccordionAddressBox>
    );
};
